<div class="container-fluid">
    <div class="card">
        <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs nav-tabs-custom g-nav-tabs-custom"
            style="padding-top: 7px;">
            <li [ngbNavItem]="1">
                <a ngbNavLink>On Call Booking</a>
                <ng-template ngbNavContent>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="p-3"></div>
        <div class="card-body">
            <form class="row" *ngIf="isOnCallActionAllowed" [formGroup]="filterForm">
                <div class="col-2">
                    <label class="font-size-font">Location<sup class="mandatory">*</sup></label>
                    <ng-multiselect-dropdown class="routing-oncall-multi" formControlName="locations"
                        [placeholder]="'Choose Locations'" [settings]="cardLocationSettings" [data]="locationList"
                        (onSelect)="onItemSelectloc()" (onDeSelect)="OnItemDeSelectloc()"
                        (onSelectAll)="onSelectAllloc()" (onDeSelectAll)="onDeSelectAllloc()">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col-2">
                    <label class="font-size-font">Site<sup class="mandatory">*</sup></label>
                    <ng-multiselect-dropdown class="routing-oncall-multi" formControlName="sites"
                        [placeholder]="'Choose Sites'" [settings]="cardSiteSettings" [data]="_mCardSitesData">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col-2">
                    <label>From date <sup class="mandatory">*</sup></label>
                    <mat-form-field appearance="outline" class="on-call-date">
                        <input matInput [matDatepicker]="fromPicker" (click)="fromPicker.open()"
                            (dateChange)="onFromDateChanged()" readonly placeholder="From date" [(ngModel)]="fromDate"
                            [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="fromPicker">
                            <img matDatepickerToggleIcon src="assets/images/bx-calendar.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-2">
                    <label>To date <sup class="mandatory">*</sup></label>
                    <mat-form-field appearance="outline" class="on-call-date">
                        <input matInput [min]="fromDate" [matDatepicker]="toPicker" (click)="toPicker.open()" readonly
                            placeholder="To date" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="toPicker">
                            <img matDatepickerToggleIcon src="assets/images/bx-calendar.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 ms-auto">
                    <div class="d-flex justify-content-end" style="margin-top: 31px;">
                        <button type="button" class="btn submit-btn-solid" (click)="submitDateFilter()">
                            Submit
                        </button>
                        <button type="button" class="btn btn-btn-grey" (click)="resetDateFilter()">
                            Reset
                        </button>
                    </div>
                </div>
            </form>
            <div class="row mt-3"
                *ngIf="isOnCallActionAllowed && (ELEMENT_DATA.length > 0 || (searchData || '').trim())">
                <div class="col-sm-3" style="width: 380px;">
                    <input class="form-control icon s-input b-0" type="text"
                        placeholder="Search by Reference No/Request No/PRO Name" [(ngModel)]="searchData"
                        (input)="searchSubject$.next($event.target.value)">
                    <small style="font-size: 12px;" class="text-muted">Search key &gt;= 3 characters.</small>
                </div>
            </div>
            <div class="row mt-3" *ngIf="_mData.length == 0 && showFlag">
                <div class="col-sm-12 col-md-12">
                    <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
                                                                  mat-color-text--blue-grey-600">
                        --No Data Found --</h4>
                </div>
            </div>

            <!-- Legacy on-call table -->
            <div class="row" *ngIf="!isOnCallActionAllowed && _mData.length > 0">
                <div class="col-sm-12">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSource" class="table table-borderless on-call-BookingsTable"
                            matPaginator>
                            <ng-container matColumnDef="site">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Site </th>
                                <td mat-cell *matCellDef="let element"> {{element.site}} </td>
                            </ng-container>

                            <ng-container matColumnDef="bookedBy">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Booked By </th>
                                <td mat-cell *matCellDef="let element"> {{element.bookedby}} </td>
                            </ng-container>

                            <ng-container matColumnDef="employeeId">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Employee Id </th>
                                <td mat-cell *matCellDef="let element"> {{element.employeeId}} </td>
                            </ng-container>

                            <ng-container matColumnDef="employeeName">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Employee Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="tripUserPassword">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Trip User Password </th>
                                <td mat-cell *matCellDef="let element"> {{element.tripUserPassword || '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="divertReason">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Divert Reason </th>
                                <td mat-cell *matCellDef="let element"> {{element.divertReason || '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="traveldate">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Travel Date </th>
                                <td mat-cell *matCellDef="let element"> {{element.travelDate}} </td>
                            </ng-container>

                            <ng-container matColumnDef="travelTime">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Travel Time </th>
                                <td mat-cell *matCellDef="let element"> {{element.travelTime}} </td>
                            </ng-container>

                            <ng-container matColumnDef="vendor">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Vendor </th>
                                <td mat-cell *matCellDef="let element"> {{element.vendor}} </td>
                            </ng-container>

                            <ng-container matColumnDef="escort">
                                <th mat-header-cell *matHeaderCellDef class="min-width"> Escort </th>
                                <td mat-cell *matCellDef="let element"> {{element.escort}} </td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th style="text-align: center;" mat-header-cell *matHeaderCellDef class="min-width">
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.status }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="min-width action-col">
                                    Action
                                </th>
                                <td mat-cell *matCellDef="let element" class="action-col">
                                    <ng-container *ngIf="hasAction(element); else noActionLegacy">
                                        <div class="action-btns"
                                            *ngIf="element.status=='Approved' && _mCurrentUserVendorFlag && !isPastTrip(element)">
                                            <button class="oncall-booking-btn"
                                                (click)="pendingStatusRequest(element,'EDIT')">Edit</button>
                                        </div>

                                        <div class="action-btns"
                                            *ngIf="element.status=='SENT_FOR_VENDOR_APPROVAL' && _mCurrentUserVendorFlag && !isPastTrip(element)">
                                            <button *ngIf="element.vendorAccepted == null" class="oncall-booking-btn"
                                                (click)="acceptTrip(element)">Accept</button>
                                            <span *ngIf="element.vendorAccepted" style="padding: 5px;">Accepted</span>
                                            <button class="oncall-booking-btn"
                                                (click)="pendingStatusRequest(element,'EDIT')">Allocate</button>
                                            <button class="oncall-booking-btn"
                                                (click)="onRejectStatusRequest(element)">Send
                                                Back To Admin</button>
                                        </div>
                                    </ng-container>
                                    <ng-template #noActionLegacy>NA</ng-template>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="_mColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: _mColumns;"></tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- New on-call card layout -->
            <div class="vendor-oncall-card-wrapper" *ngIf="isOnCallActionAllowed && _mData.length > 0">
                <div class="vendor-oncall-card-table">
                    <div class="vendor-oncall-card-head">
                        <div class="voc-col voc-col-ref">Reference No.</div>
                        <div class="voc-col voc-col-request">Request No.</div>
                        <div class="voc-col voc-col-pro">PRO Name</div>
                        <div class="voc-col voc-col-dates">Date &amp; Reporting Time</div>
                        <div class="voc-col voc-col-route">Pick Up From &nbsp;&rarr;&nbsp; Drop To</div>
                        <div class="voc-col voc-col-vehicle">Vehicle Type</div>
                        <div class="voc-col voc-col-driver">Driver</div>
                        <div class="voc-col voc-col-vehicleNo">Vehicle No.</div>
                        <div class="voc-col voc-col-status">Status</div>
                        <div class="voc-col voc-col-action">Action</div>
                    </div>

                    <div class="vendor-oncall-card-group" *ngFor="let element of ELEMENT_DATA">
                        <div class="vendor-oncall-card-row" [class.expanded]="isRowExpanded(element)">
                            <div class="voc-col voc-col-ref">
                                <em class="bx"
                                    [ngClass]="isRowExpanded(element) ? 'bx-chevron-down' : 'bx-chevron-right'"
                                    (click)="toggleRow(element)"></em>
                                <span class="ref-text">{{ element.referenceNo }}</span>
                            </div>
                            <div class="voc-col voc-col-request" [matTooltip]="element.requestNo"
                                matTooltipShowDelay="400">
                                {{ element.requestNo || '-' }}
                            </div>
                            <div class="voc-col voc-col-pro" [matTooltip]="element.proDisplayName"
                                matTooltipShowDelay="400">
                                {{ element.proDisplayName }}
                            </div>
                            <div class="voc-col voc-col-dates"
                                [matTooltip]="element.travelDate + ' ' + (element.travelTime || '-')"
                                matTooltipShowDelay="400">
                                <div class="date-value">{{ element.travelDate }}</div>
                                <div class="time-value">{{ element.travelTime || '-' }}</div>
                            </div>
                            <div class="voc-col voc-col-route"
                                [matTooltip]="element.pickUpFrom + ' → ' + element.dropTo" matTooltipShowDelay="400">
                                <div class="route-from">{{ element.pickUpFrom }}</div>
                                <div class="route-arrow"><em class="bx bx-down-arrow-alt"></em></div>
                                <div class="route-to">{{ element.dropTo }}</div>
                            </div>
                            <div class="voc-col voc-col-vehicle" [class.unassigned]="isUnassigned(element.vehicleType)">
                                {{ element.vehicleType }}
                            </div>
                            <div class="voc-col voc-col-driver" [class.unassigned]="isUnassigned(element.driver)"
                                [matTooltip]="element.driver" matTooltipShowDelay="400">
                                {{ element.driver }}
                            </div>
                            <div class="voc-col voc-col-vehicleNo"
                                [class.unassigned]="isUnassigned(element.vehicleNumber)"
                                [matTooltip]="element.vehicleNumber" matTooltipShowDelay="400">
                                {{ element.vehicleNumber }}
                            </div>
                            <div class="voc-col voc-col-status">
                                <span class="status-pill" [ngClass]="element.status">{{ cardStatusLabel(element) }}</span>
                            </div>
                            <div class="voc-col voc-col-action">
                                <ng-container *ngIf="hasAction(element); else noActionNew">
                                    <button type="button" class="voc-action-btn reset"
                                        *ngIf="canResetRunningTrip(element)"
                                        matTooltip="Reset running trip to assign a replacement vehicle"
                                        (click)="resetRunningTrip(element)">Reset</button>

                                    <ng-container
                                        *ngIf="element.status=='SENT_FOR_VENDOR_APPROVAL' && !isNewFlowActionBlocked(element)">
                                        <button type="button" class="voc-action-btn approve"
                                            (click)="acceptTrip(element)">Accept</button>
                                        <button type="button" class="voc-action-btn reject"
                                            (click)="rejectOnCallBooking(element)">Reject</button>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="element.status=='ACCEPTED_BY_VENDOR' && !isNewFlowActionBlocked(element)">
                                        <button type="button" class="voc-action-btn approve"
                                            (click)="openApproveDialog(element)">Approve</button>
                                        <button type="button" class="voc-action-btn reject"
                                            (click)="rejectOnCallBooking(element)">Reject</button>
                                    </ng-container>

                                    <ng-container *ngIf="isApprovedStatus(element) && !isNewFlowActionBlocked(element)">
                                        <button type="button" class="voc-action-btn edit"
                                            (click)="openApproveDialog(element, true)">Edit</button>
                                        <button type="button" class="voc-action-btn restart"
                                            *ngIf="isOnCallActionAllowed && (deviceStatus =='stopped' || deviceStatus =='STOPPED')"
                                            (click)="restartTrip(element)">Restart</button>
                                    </ng-container>
                                </ng-container>
                                <ng-template #noActionNew>
                                    <span class="no-action">&mdash;</span>
                                </ng-template>
                            </div>
                        </div>

                        <div class="vendor-oncall-card-detail" *ngIf="isRowExpanded(element)">
                            <table class="vendor-merged-detail-table">
                                <thead>
                                    <tr>
                                        <th>Site</th>
                                        <th>Employee Name</th>
                                        <th>Employee Id</th>
                                        <th>OTP</th>
                                        <th>Divert Reason</th>
                                        <th>Vendor Reject Reason</th>
                                        <th>Booked By</th>
                                        <th>Escort</th>
                                        <th>Driver Number</th>
                                        <th>Running Status</th>
                                        <th>Instruction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let passenger of (element.passengers || []); let i = index">
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.site || 'NA' }}
                                        </td>
                                        <td>{{ passenger.name || 'NA' }}</td>
                                        <td>{{ passenger.employeeId || 'NA' }}</td>
                                        <td>{{ passenger.password || 'NA' }}</td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.divertReason || 'NA' }}
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.vendorRejectReason || 'NA' }}
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.bookedby || 'NA' }}
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.escort || 'NA' }}
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.driverNumber || 'NA' }}
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            <span class="running-status" [class.is-running]="isTripRunning(element)">
                                                {{ element.deviceTripStatus || 'NA' }}
                                            </span>
                                        </td>
                                        <td *ngIf="i === 0" [attr.rowspan]="(element.passengers || []).length || 1">
                                            {{ element.reason || 'NA' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="vendor-oncall-card-footer">
                    <span class="showing-text">Showing {{ ELEMENT_DATA.length }} booking{{ ELEMENT_DATA.length === 1 ?
                        '' : 's' }}</span>
                </div>
            </div>
        </div>
    </div>
</div>